// src/components/evenement/WhatsappStep.js
import { FaWhatsapp, FaCheckCircle, FaTimes } from 'react-icons/fa';
import './WhatsappStep.css';

const WhatsappStep = ({ onClose, onFinish, userName }) => {
  // ✅ Lien WhatsApp correct pour la Côte d'Ivoire
  const WHATSAPP_GROUP_LINK = 'https://chat.whatsapp.com/Cngg93r0mFaEr0vji36JZW';

  const handleJoinWhatsApp = () => {
    window.open(WHATSAPP_GROUP_LINK, '_blank');
  };

  const handleLater = () => {
    if (onFinish) {
      onFinish();
    } else {
      onClose();
    }
  };

  return (
    <div className="whatsappStepContainer">
      <div className="whatsappHeader">
        <div className="whatsappHeaderIcon">
          <FaWhatsapp />
        </div>
        <h2>
          Rejoignez notre <span className="whatsappGradient">groupe WhatsApp</span>
        </h2>
        <p>
          {userName ? `${userName}, f` : 'F'}élicitations pour votre inscription !
        </p>
      </div>

      <div className="whatsappContent">
        <div className="whatsappSuccessBadge">
          <div className="whatsappSuccessIcon">
            <FaCheckCircle />
          </div>
          <p className="whatsappSuccessText">
            Votre inscription au Forum de Préparation au Départ en France a été enregistrée avec succès !
          </p>
        </div>

        {/* BOUTON REJOINDRE LE GROUPE - EN DESSOUS ET PLUS VISIBLE */}
        <div className="whatsappButtonGroup">
          <button 
            onClick={handleJoinWhatsApp} 
            className="whatsappJoinBtn"
          >
            <FaWhatsapp />
            Rejoindre le groupe WhatsApp
          </button>
        </div>

        <div className="whatsappMessageBox">
          <div className="whatsappMessageIcon">
            <FaWhatsapp />
          </div>
          <h3>Pourquoi rejoindre notre communauté ?</h3>
          <p>
            En rejoignant notre groupe WhatsApp, vous pourrez :
          </p>
          <ul className="whatsappBenefitsList">
            <li>
              <FaCheckCircle className="benefitIcon" />
              <span>Recevoir les informations sur le forum</span>
            </li>
            <li>
              <FaCheckCircle className="benefitIcon" />
              <span>Obtenir des conseils d'experts</span>
            </li>
            <li>
              <FaCheckCircle className="benefitIcon" />
              <span>Échanger avec d'autres participants</span>
            </li>
            <li>
              <FaCheckCircle className="benefitIcon" />
              <span>Être informé des actualités</span>
            </li>
          </ul>
        </div>

        <div className="whatsappButtonGroup">
          <button onClick={handleLater} className="whatsappLaterBtn">
            <FaTimes />
            Plus tard
          </button>
        </div>

        <div className="whatsappLegal">
          En rejoignant le groupe, vous acceptez de recevoir des messages de l'ETEF Côte d'Ivoire.
          Vous pourrez quitter le groupe à tout moment.
        </div>
      </div>
    </div>
  );
};

export default WhatsappStep;